import React, { useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import PaginationSection from "../../components/Product/Pagination";
import { NOTICE_LIST_URL } from '../../utils/urls';
import instance from '../../services/services';
import { useLanguage } from "../../hooks/useLanguage";

function NoticeList() {
  const { t } = useLanguage();
  const [noticeData, setNoticeData] = useState([]);
  const [topNoticeData, setTopNoticeData] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 12; // 페이지당 표시할 항목 수
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchNotice = async () => {
      try {
        const response = await instance.post(NOTICE_LIST_URL, {
          "boardid" : "notice",   
          "offset" : currentPage,
          "limit" : itemsPerPage
        });
        setNoticeData(response.data.data.data)
        setTopNoticeData(response.data.data.topData)
        setTotalCount(response.data.data.cntRow)

      } catch (error) {
        console.error("마이페이지 정보 가져오기 실패:", error);
      }
    };
    fetchNotice();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // window.scrollTo(0, 0); // 페이지 상단으로 스크롤
  };

  const handleArrowClick = (page) => {
    handlePageChange(page);
  };

  return (
    <div className="board_container">
      <h3 className="commu_title">{t("notice")}</h3>

      <ul className="board_list">
        {/* 12개 게시글 노출  */}
        {topNoticeData && Object.keys(topNoticeData).length > 0 && (
        <li className='board_list_con'>
        {/* '공지' 뱃지 있음 > 최상단 고정 */}
          <Link
            to={`/community/notice/${topNoticeData?.b_seq}`}
            className="title ellipsis1"
            // style={{whiteSpace:"normal" , width:"100%"}}
          >
            <span className="badge black">{t("notification")}</span>
            {topNoticeData?.subject}
          </Link>
          <span className="date">
            {topNoticeData?.regist_date?.split(' ')[0]}
          </span>
        </li>
        )}
        
        {noticeData.map((notice, index) => (
          <li 
            key={index}
            className='board_list_con'
          >
            <Link
              to={`/community/notice/${notice?.b_seq}`}
              className="title ellipsis1"
              // style={{whiteSpace:"normal" , width:"100%"}}
            >
              {notice?.top_fixed === 'Y' && <span className="badge black">공지</span>}
              {notice?.subject}
            </Link>
            <span className="date">
              {notice?.regist_date?.substring(0, 16)}
            </span>
          </li>
        ))}
      </ul>
      <PaginationSection
        totalCount={totalCount}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        onArrow={handleArrowClick}
      />
    </div>
  );
}

export default NoticeList;